const BASE_SIZE = 16

export const pxToREM = ({ px }: { px: number }) => `${px / BASE_SIZE}rem`
